import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useBangKeHoaDonBanHangExport = (queryParams?: BanHangSearchParams, subtitle?: string) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportBangKeHoaDonBanHangFromApi } = await import('../utils/excel-export');
      await exportBangKeHoaDonBanHangFromApi({
        entitySlug: entity.slug,
        queryParams,
        excelOptions: subtitle ? { subtitle } : undefined
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams),
    isExporting
  };
};
